/**
 * Created by Kieran on 23/10/2017.
 */

import Toastr from 'toastr';
const toastr = {};

Toastr.options = {
  closeButton: false,
  newestOnTop: false,
  progressBar: false,
  positionClass: "toast-bottom-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: 300,
  hideDuration: 300,
  timeOut: 3000,
  extendedTimeOut: 1000,
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut"
};

toastr.install = function (Vue) {
  Vue.prototype.$toastr = Toastr;
};

export default toastr;



// WEBPACK FOOTER //
// ./src/plugins/toastr/index.js